import * as MemoryCache from 'memory-cache';
import TokenResponse from 'owa-service/lib/contract/TokenResponse';

let promiseForResourceCache: MemoryCache = null;

/**
 * This provides caching to store network promise to resource mapping.
 * Used when similar network requests are made for the same resource, this cache
 * is looked up to return an existing promise to the caller.
 */
function getPromiseForResourceCache(): MemoryCache {
    if (promiseForResourceCache == null) {
        promiseForResourceCache = new MemoryCache.Cache();
    }
    return promiseForResourceCache;
}

export function getCachedPromiseForResource(resource: string): Promise<TokenResponse> {
    const cachedToken = getPromiseForResourceCache().get(resource) as Promise<TokenResponse>;
    return cachedToken;
}

export function removeCachedPromiseForResource(resource: string): boolean {
    return getPromiseForResourceCache().del(resource);
}

export function putPromiseForResourceInCache(resource: string, promise: Promise<TokenResponse>) {
    getPromiseForResourceCache().put(resource, promise);
}
